// Чистые функции страницы «Чёрный список VIN» — отдельно от разметки, чтобы проверять тестом.

export const ALLOWED_EXTENSIONS = ['.xlsx', '.xls', '.csv'];
export const MAX_FILE_SIZE_MB = 10;

// Текст ошибки для выбранного файла; пустая строка — файл годится.
export const fileProblem = (file) => {
  const name = file?.name || '';
  const dot = name.lastIndexOf('.');
  const ext = dot === -1 ? '' : name.slice(dot).toLowerCase();
  if (!ALLOWED_EXTENSIONS.includes(ext)) {
    return `Файл «${name}»: недопустимый формат. Загрузите .xlsx, .xls или .csv`;
  }
  if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    return `Файл «${name}» больше ${MAX_FILE_SIZE_MB} МБ`;
  }
  return '';
};

// Итог загрузки файла для менеджера: сколько добавлено, сколько уже было, какие строки пропущены.
export const importSummary = (data) => {
  const added = data?.added ?? 0;
  const already = data?.alreadyInList ?? 0;
  const bad = data?.badRows || [];
  const parts = [`Добавлено: ${added}`];
  if (already > 0) parts.push(`уже были в списке: ${already}`);
  if (bad.length > 0) {
    const rows = bad
      .slice(0, 10)
      .map((item) => item.row)
      .join(', ');
    parts.push(`пропущено строк без корректного VIN: ${bad.length} (строки ${rows}${bad.length > 10 ? '…' : ''})`);
  }
  return parts.join(', ');
};

export const VIN_LENGTH = 17;

// Ввод VIN: заглавные латиница и цифры, не длиннее 17 (как везде в карточке авто)
export const normalizeVinInput = (raw) =>
  String(raw || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, VIN_LENGTH);

// Пример файла для импорта: UTF-8 с BOM и «;» — так его открывает русский Excel, бэк читает и такой CSV
export const SAMPLE_CSV = '\uFEFFVIN;Причина\r\nWVWZZZ1JZXW000001;Поддельный ПТС\r\nLSVNN2184C2000002;\r\n';
export const SAMPLE_CSV_HREF = `data:text/csv;charset=utf-8,${encodeURIComponent(SAMPLE_CSV)}`;
